import { useState } from "react";
import { ModalContext, useModalContext } from "@context/use-modal-context";
import { ModalContextData, ModalContextState } from "@idw-types/context";

export const ModalContainer = () => {
    const [recursiveModalState, setRecursiveModalState] = useState<ModalContextState>({
        modalType: undefined,
        renderFunction: undefined
    });

    const modalContext = useModalContext();
    const { modalState, setModalState } = modalContext;

    const onModalClose = () => {
        setModalState({
            modalType: undefined,
            renderFunction: undefined
        });
    };

    const setRecursiveModalContextState = (modalState: ModalContextState) => {
        setRecursiveModalState(modalState);
    };

    const recursiveModalContext = (): ModalContextData => {
        return {
            modalState: recursiveModalState,
            setModalState: setRecursiveModalContextState
        };
    };

    if (modalState?.modalType) {
        return (
            <ModalContext.Provider value={recursiveModalContext()}>
                {modalState.renderFunction(onModalClose)}
                <ModalContainer />
            </ModalContext.Provider>
        );
    }

    return null;
};